export const isFiniteNumber = (num?: number) => {
  if (typeof num === 'undefined') {
    return false;
  }

  return Number.isFinite(num) && !Number.isNaN(num);
};
